module.exports = __webpack_public_path__ + "static/media/code1.f489d496.PNG";